<div *ngIf="policyContent" class="policy-container">
    <h1>{{policyContent.title}}</h1>
    <div class="rich-text-content" [innerHtml]="policyContent.content | safeHtml"></div>
</div>